import { createFileRoute } from '@tanstack/react-router'
import { StateModelCreatePage } from '@/pages/settings/state-model-editor/state-model-create-page'
import { WorkspaceEntitlementGate } from '@/features/workspace-entitlements/ui/workspace-entitlement-gate'
import { WorkspaceEntitlementKey } from '@/graphql/schema'

export const Route = createFileRoute('/settings/state-models_/new')({
  component: () => (
    <WorkspaceEntitlementGate
      feature={WorkspaceEntitlementKey.StateModelConfiguration}
    >
      <StateModelCreatePage />
    </WorkspaceEntitlementGate>
  ),
})
